var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _simpleMarkdown = _interopRequireDefault(require("simple-markdown"));
var _styles = require("./styles");
var _reactNative = require("react-native-web");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports["default"] = Object.assign({}, _simpleMarkdown["default"].defaultRules.link, {
  react: function react(node, output, state) {
    var _ref;
    var _useStyles = (0, _styles.useStyles)({
        sharedStyles: state.sharedStyles
      }),
      styles = _useStyles.styles;
    var _isAppHref = (_ref = node.target.indexOf('http') === -1) != null ? _ref : false;
    var _url = state.navigationContext.transform(node.target);
    var _linkArgs = {};
    _linkArgs.href = _url;
    if (!_isAppHref) {
      _linkArgs.target = '_blank';
      _linkArgs.rel = 'noreferrer';
    }
    var _onPress = function _onPress() {
      state.navigationContext.navigate(_url);
    };
    if (_reactNative.Platform.OS === 'web') {
      var _defaultStyles = _reactNative.StyleSheet.flatten([styles.link, state.textStyle]);
      var _focusStyles = _reactNative.StyleSheet.flatten([styles.link, state.textStyle, styles.link_focused]);
      var _onFocus = function _onFocus(event) {
        if (event.target) {
          event.target.setAttribute('style', '');
          Object.entries(_focusStyles).forEach(function (entry) {
            var _entry = (0, _slicedToArray2["default"])(entry, 2),
              key = _entry[0],
              value = _entry[1];
            event.target.style[key] = value;
          });
        }
      };
      var _onBlur = function _onBlur(event) {
        if (event.target) {
          event.target.setAttribute('style', '');
          Object.entries(_defaultStyles).forEach(function (entry) {
            var _entry2 = (0, _slicedToArray2["default"])(entry, 2),
              key = _entry2[0],
              value = _entry2[1];
            event.target.style[key] = value;
          });
        }
      };
      return (0, _jsxRuntime.jsx)("a", Object.assign({}, _linkArgs, {
        style: _defaultStyles,
        onFocus: _onFocus,
        onBlur: _onBlur,
        children: output(node.content, state)
      }), state.key);
    }
    return (0, _jsxRuntime.jsx)(_reactNative.Text, {
      style: [styles.link, state.textStyle],
      onPress: _onPress,
      children: output(node.content, state)
    }, state.key);
  }
});